import React from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';

const LodgingFormPlaceholder: React.FC<any> = ({ initialData = {}, onSave, onCancel }) => {
  const [name, setName] = React.useState(initialData.title || initialData.hotelName || '');
  const [address, setAddress] = React.useState(initialData.address || '');
  const [checkIn, setCheckIn] = React.useState(initialData.checkin_time || '');
  const [checkOut, setCheckOut] = React.useState(initialData.checkout_time || '');

  return (
    <View style={styles.wrap}>
      <Text style={styles.heading}>Lodging (占位表单)</Text>
      <TextInput style={styles.input} placeholder="名称" value={name} onChangeText={setName} />
      <TextInput style={styles.input} placeholder="地址" value={address} onChangeText={setAddress} />
      <TextInput style={styles.input} placeholder="入住时间" value={checkIn} onChangeText={setCheckIn} />
      <TextInput style={styles.input} placeholder="退房时间" value={checkOut} onChangeText={setCheckOut} />

      <View style={styles.actions}>
        <TouchableOpacity onPress={() => onCancel && onCancel()} style={[styles.btn, styles.cancel]}>
          <Text>取消</Text>
        </TouchableOpacity>
        <TouchableOpacity onPress={() => onSave && onSave({ name, address, checkIn, checkOut })} style={[styles.btn, styles.save]}>
          <Text style={{ color: '#fff' }}>保存</Text>
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrap: { padding: 12 },
  heading: { fontSize: 18, fontWeight: '700', marginBottom: 12 },
  input: { borderWidth: 1, borderColor: '#eee', padding: 8, marginBottom: 8, borderRadius: 6 },
  actions: { flexDirection: 'row', justifyContent: 'flex-end' },
  btn: { padding: 8, borderRadius: 6, marginLeft: 8 },
  cancel: { backgroundColor: '#f3f4f6' },
  save: { backgroundColor: '#0ea5ff' },
});

export default LodgingFormPlaceholder;
